// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__OB1g2","subheader":"ReorderModal_subheader__uLKGC","listWrap":"ReorderModal_listWrap__3Jk7c"};